import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import CreateNatureBusinessModal from '../components/CreateNatureBusinessModal';
import UpdateNatureBusinessModal from '../components/UpdateNatureBusinessModal';
import RegionContent from './RegionContent';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
};

function RegionContainer({
  match,
  isLoading,
  history,
  getRegionList,
  lineBusinessList,
  lineBusinessListPager,
  removeNatureBusiness,
  getNatureBusinessList,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Region',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Region',
      modalSize: 'modal-md',
    });
  };

  // const handleRemove = data => e => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure you want to remove this Region?',
  //     () => {
  //       removeLineBusiness(data.id, () => {
  //         getRegionList();
  //         const id = _.get(lineBusinessList, '0.id');
  //         history.push(`/general-settings/address/region/${id}`);
  //         getNatureBusinessList(id);
  //       });
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const handleAddNatureBusinessModal = (id) => () => {
    setModal({
      isOpen: true,
      content: <CreateNatureBusinessModal id={id} />,
      title: 'Add Nature Business',
      modalSize: 'modal-md',
    });
  };

  const handleEditNatureBusiness = (businessId, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateNatureBusinessModal
          updateList={data.attributes}
          id={businessId}
          natureBusinessId={data.id}
        />
      ),
      title: 'Update Nature Business',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveNatureBusiness = (businessId, data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this nature business?',
      () => {
        removeNatureBusiness(businessId, data.id, () => {
          getNatureBusinessList(businessId);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getRegionList({ isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getRegionList({ name: formData.keyword, q: formData.keyword, isPaginate: 1 });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);
  return (
    <Route
      path={`${match.path}/:regionId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Region List"
          getData={getRegionList}
          setParams={param}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'keyword') || ''}
          keywordPlaceholder="Search Region..."
          pathName={`${match.path}/:regionId?`}
          listName="Region"
          label="Region"
          renderItem={(item) => (
            <div className="p-3">
              <div className="transaction-list-company">
                {_.get(item, 'attributes.name')}
              </div>
            </div>
          )}
          isLoading={isLoading}
          selected={params.regionId}
          data={lineBusinessList}
          dataPager={lineBusinessListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:regionId?`}
                  render={() => (
                    <RegionContent
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      handleAddNatureBusinessModal={
                        handleAddNatureBusinessModal
                      }
                      handleEditNatureBusiness={handleEditNatureBusiness}
                      handleRemoveNatureBusiness={handleRemoveNatureBusiness}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:regionId?`}
                render={() =>
                  !params.regionId && lineBusinessList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(lineBusinessList, '0.id')}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

RegionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRegionList: PropTypes.instanceOf(Function).isRequired,
  lineBusinessList: PropTypes.instanceOf(Array).isRequired,
  lineBusinessListPager: PropTypes.instanceOf(Object).isRequired,
  // removeLineBusiness: PropTypes.instanceOf(Function).isRequired,
  removeNatureBusiness: PropTypes.instanceOf(Function).isRequired,
  getNatureBusinessList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_REGION) > -1,
  lineBusinessList: _.get(api, `${c.GET_REGION}.list`) || [],
  lineBusinessListPager: _.get(api, `${c.GET_REGION}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RegionContainer);
